export default __webpack_public_path__ + "static/bookmetadata-0cd0ba4e508659314386f1bf50095a83.png";